module.exports = __webpack_public_path__ + "img/design-demo.18eb051e.jpeg";